import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { openTooltip } from "../../store/actions";
import { isTouchScreen } from "../../lib/elementUtilities";

interface IProps {
  title: string;
  content: string;
  classes?: string[];
  iconClasses?: string[];
}

const mapDispatchToProps = (dispatch: any) => ({
  openTooltipDispatch: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions)),
});

const connector = connect(null, mapDispatchToProps);

const HelpIcon = ({
  title,
  content,
  classes,
  iconClasses,
  openTooltipDispatch,
}: IProps & ConnectedProps<typeof connector>) => {
  const iconRef = useRef<HTMLAnchorElement>(null);

  return (
    <a
      ref={iconRef}
      onMouseEnter={() => !isTouchScreen() && openTooltipDispatch({
        static: true,
        name: title,
        classes,
        title,
        content,
        elementRef: iconRef
      })}
      onMouseOver={() => !isTouchScreen() && openTooltipDispatch({
        static: true,
        name: title,
        classes,
        title,
        content,
        elementRef: iconRef
      })}
      onClick={() => openTooltipDispatch({
        static: true,
        name: title,
        classes,
        title,
        content,
        elementRef: iconRef
      })}
    >
      <i className={`icon-circle ${iconClasses?.join(" ")}`}>?</i>
    </a>
  )
}

export default connector(HelpIcon);
